import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isArray } from '../../core/utils/utils';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {
  }

  transform(value: any, translate?: boolean, args?: string | string[] | any): any {
    if (!value) {
      return;
    }
    if (isArray(value)) {
      value = value[0];
    }

    return isNotNullOrUndefined(translate) && !translate ? value : this.translateValue(value, args);
  }

  private translateValue(value: any, args: string | string[]) {
    let translatedText = this.translate.instant(value, args);
    if (translatedText === value && translatedText.indexOf('.') > -1 && translatedText.indexOf(' ') === -1) {
      const split = translatedText.split('.')
      const v = split[split.length - 1];
      if (v !== 'undefined') {
        try {
          translatedText = this.translate.instant(v, args);
        } catch {
          return translatedText;
        }
      } else {
        return translatedText;
      }
    }
    return translatedText;
  }
}
